import { getAuthToken } from 'utils/cookies';
import { isEmpty, size } from 'lodash';

export const isAuthenticated = () => {
  const token = getAuthToken();
  const auth_token = localStorage.getItem('session_token');
  return !!token || !!auth_token;
};

export const getTokenInStorage = () => getAuthToken();

export const hasPublishPermission = ({ permissions }) => {
  if (typeof permissions === 'string') {
    const arrayPermissions = permissions.split(',');
    const publishPermission = arrayPermissions.filter(permission => permission.trim() === '"publishing.view": true');
    return publishPermission.length;
  }
  if (isEmpty(permissions) || !size(permissions)) return false;
  return permissions['publishing.view'] || false;
};

export const saveUserRole = (userRole) => {
  localStorage.setItem('userRole', userRole);
  return true;
};

export const getUserRole = () => {
  return localStorage.getItem('userRole');
};
